import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs/internal/Subject';
import { AuthService } from 'src/app/modules/core/services/auth/auth.service';

@Component({
  selector: 'app-accept-counter-offer-remarks',
  templateUrl: './accept-counter-offer-remarks.component.html',
  styleUrls: ['./accept-counter-offer-remarks.component.scss']
})
export class AcceptCounterOfferRemarksComponent implements OnInit {

  public statusForm!: FormGroup;
  public remarks!: string;

  public onClose = new Subject<any>();

  constructor(public bsModalRef: BsModalRef,
    private _formBuilder: FormBuilder) {
      this.statusForm = this._formBuilder.group({
        remarks : [null, [Validators.required]]
      });
     }

  ngOnInit(): void {
  }

  public submit(){
    this.bsModalRef.hide()
    this.onClose.next(this.remarks);
  }
}
